import {exists} from "./wvn_exist";

var dropdown = {
  menu : function (elementHtmlTag) {
    elementHtmlTag.querySelectorAll('li.depth-0:not(.items-nb-0) > a, li.depth-0:not(.items-nb-0) > button').forEach(function (el, index, array) {
      _dropdownPrivate.init(el, elementHtmlTag);
    });
  },
  default : function (elementHtmlTag) {
    elementHtmlTag.querySelectorAll('button.dropdown--button').forEach(function (el, index, array) {
      _dropdownPrivate.init(el, elementHtmlTag);
    });
  }
};

var _dropdownPrivate = {
  init : function (expandButtonElement, parentElement) {
    /*
    * Init
    * */
    _dropdownPrivate.open(expandButtonElement, parentElement, 'close');

    /*
    * Add event
    * */
    expandButtonElement.addEventListener('mouseenter', function (e) {
      _dropdownPrivate.open(e.currentTarget, parentElement, 'open');
    });

    parentElement.addEventListener('mouseleave', function (e) {
      _dropdownPrivate.open(expandButtonElement, parentElement, 'close');
    });
  },
  open : function (expandButtonElement, parentElement, forceState) {
    /*
     * Check if valid variable
     * */
    if (!exists(expandButtonElement)) {
      return;
    }

    /*
     * Expand or not ?
     *
     * if variable forceState exists and 'open' => Expand it !
     * if variable forceState exists and 'close' => Close it !
     * if variable forceState does exist => Toggle
     * */
    if (exists(forceState)
      && (forceState == 'open' || forceState == 'close')
      ) {
      var expandIt = forceState == 'open';
    }
    else {
      var expandIt = expandButtonElement.parentNode.classList.contains('dropdown-close');
    }

    /*
     * Close all the dropdowns (except the current)
     * Before opening/closing the selected dropdown
     */
    parentElement.querySelectorAll('.dropdown-open').forEach(function (elt) {
      if (expandButtonElement.parentNode != elt) {
        elt.classList.remove('dropdown-open');
        elt.classList.add('dropdown-close');
      }
    });

    /*
    * Do it !
    * */
    expandButtonElement.parentNode.classList.remove(expandIt ? 'dropdown-close' : 'dropdown-open');
    expandButtonElement.parentNode.classList.add(expandIt ? 'dropdown-open' : 'dropdown-close');
  }
};

export default dropdown;
